import { ReactNode } from "react";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type ViewHeaderNavigationProps = {
  children: ReactNode;
  role?: string;
};

const ViewHeaderNavigation = ({ children, role }: ViewHeaderNavigationProps) => {
  return (
    <Box
      align="center"
      justify="start"
      margin="medium 0 0"
      gap="medium"
      fullWidth
      role={role}
      className={styles.wrapper}
    >
      {children}
    </Box>
  );
};

export default ViewHeaderNavigation;
